const coachingVideoMapping = {
  broadcast: "BROADCAST",
  alternateBroadcast: "ALTERNATE_BROADCAST",
  pitchcast: "PITCHCAST",
  centerfield: "CENTERFIELD",
  chHighSideview: "CH_HIGH_SIDEVIEW",
  highHome: "HIGH_HOME",
  midHome: "MID_HOME",
  broadcastReview: "BROADCAST_REVIEW",
  alternateBroadcastReview: "ALTERNATE_BROADCAST_REVIEW",
  firstBaseBatterSideview: "1B_BATTER_SIDEVIEW",
  thirdBaseBatterSideview: "3B_BATTER_SIDEVIEW",
  firstBasePitcherSideview: "1B_PITCHER_SIDEVIEW",
  thirdBasePitcherSideview: "3B_PITCHER_SIDEVIEW",
};

export default coachingVideoMapping;
